"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _main = require("../main");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getDays = function getDays(innerDate) {
  var monthDayCells = [];
  var lastMonthNumberOfDays = innerDate.set("month", innerDate.get("month") - 1).endOf("month");
  var firstDayOfMonth = innerDate.startOf("month").day() === 0 ? 6 : innerDate.startOf("month").day() - 1;
  var daysInMonth = firstDayOfMonth + innerDate.daysInMonth();

  for (var i = 0; i < 42; i++) {
    if (i < firstDayOfMonth) {
      monthDayCells.push({
        day: lastMonthNumberOfDays.get("date") - firstDayOfMonth + i + 1,
        month: innerDate.get("month") ? innerDate.get("month") - 1 : 11,
        year: innerDate.set("month", innerDate.get("month") - 1).get("year")
      });
    } else if (i < daysInMonth) {
      monthDayCells.push({
        day: i - firstDayOfMonth + 1,
        month: innerDate.get("month"),
        year: innerDate.get("year")
      });
    } else {
      monthDayCells.push({
        day: i - daysInMonth + 1,
        month: innerDate.get("month") === 11 ? 0 : innerDate.get("month") + 1,
        year: innerDate.set("month", innerDate.get("month") + 1).get("year")
      });
    }
  }

  return monthDayCells;
};

var isDaySelected = function isDaySelected(date, selectedDate) {
  return (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.get("month")) === date.month && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.get("year")) === date.year && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.get("date")) === date.day;
};

var Calendar = function Calendar(_ref) {
  var selectedDate = _ref.selectedDate,
      innerDate = _ref.innerDate,
      onInnerDateChange = _ref.onInnerDateChange,
      onDaySelect = _ref.onDaySelect;

  var _useState = (0, _react.useState)((selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.get("month")) === innerDate.get("month") && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.get("year")) === innerDate.get("year") ? selectedDate : (0, _dayjs["default"])()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      dateToFocus = _useState2[0],
      setDateToFocus = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      toFocus = _useState4[0],
      setToFocus = _useState4[1];

  var today = (0, _dayjs["default"])();
  var dayCells = (0, _react.useMemo)(function () {
    return getDays(innerDate);
  }, [innerDate]);
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var weekDays = translatedLabels.calendar.daysShort;

  var onDateClickHandler = function onDateClickHandler(date) {
    var newDate = innerDate.set("month", date.month).set("date", date.day);
    onDaySelect(newDate);
    setDateToFocus(newDate);
  };

  var handleOnBlur = function handleOnBlur(event) {
    if (!(event !== null && event !== void 0 && event.currentTarget.contains(event.relatedTarget))) {
      updateDateToFocus();
    }
  };

  var updateDateToFocus = function updateDateToFocus() {
    if ((selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.get("month")) === innerDate.get("month") && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.get("year")) === innerDate.get("year")) {
      setDateToFocus(selectedDate);
    } else if (today.get("month") === innerDate.get("month") && today.get("year") === innerDate.get("year")) {
      setDateToFocus(today);
    } else {
      setDateToFocus(innerDate.set("date", 1));
    }
  };

  var focusDate = function focusDate(date) {
    if (innerDate.get("month") !== date.get("month") || innerDate.get("year") !== date.get("year")) {
      onInnerDateChange(date);
    }

    setDateToFocus(date);
    setToFocus(true);
  };

  (0, _react.useEffect)(function () {
    if (toFocus) {
      var _document$getElementB;

      (_document$getElementB = document.getElementById("day_".concat(dateToFocus.get("date"), "_month").concat(dateToFocus.get("month")))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
      setToFocus(false);
    }
  }, [dateToFocus, toFocus]);
  (0, _react.useEffect)(function () {
    if (dateToFocus.get("month") !== innerDate.get("month") || dateToFocus.get("year") !== innerDate.get("year")) {
      updateDateToFocus();
    }
  }, [innerDate, dateToFocus, selectedDate]);

  var handleDayKeyboardEvent = function handleDayKeyboardEvent(event, date) {
    var dateToFocusTemp = date.month === innerDate.get("month") ? innerDate.set("date", date.day) : innerDate.set("date", date.day).set("month", date.month);

    switch (event.key) {
      case "PageUp":
        event.preventDefault();
        event.shiftKey ? dateToFocusTemp = dateToFocusTemp.set("year", dateToFocusTemp.get("year") - 1) : dateToFocusTemp = dateToFocusTemp.set("month", dateToFocusTemp.get("month") - 1);
        focusDate(dateToFocusTemp);
        break;

      case "PageDown":
        event.preventDefault();
        event.shiftKey ? dateToFocusTemp = dateToFocusTemp.set("year", dateToFocusTemp.get("year") + 1) : dateToFocusTemp = dateToFocusTemp.set("month", dateToFocusTemp.get("month") + 1);
        focusDate(dateToFocusTemp);
        break;

      case "ArrowLeft":
        event.preventDefault();
        dateToFocusTemp = dateToFocusTemp.set("date", dateToFocusTemp.get("date") - 1);
        focusDate(dateToFocusTemp);
        break;

      case "ArrowRight":
        event.preventDefault();
        dateToFocusTemp = dateToFocusTemp.set("date", dateToFocusTemp.get("date") + 1);
        focusDate(dateToFocusTemp);
        break;

      case "ArrowUp":
        event.preventDefault();
        dateToFocusTemp = dateToFocusTemp.set("date", dateToFocusTemp.get("date") - 7);
        focusDate(dateToFocusTemp);
        break;

      case "ArrowDown":
        event.preventDefault();
        dateToFocusTemp = dateToFocusTemp.set("date", dateToFocusTemp.get("date") + 7);
        focusDate(dateToFocusTemp);
        break;

      case "Home":
        event.preventDefault();
        dateToFocus.get("day") !== 0 ? dateToFocusTemp = dateToFocusTemp.day(1) : dateToFocusTemp = innerDate.date(date.day - 1).day(1);
        focusDate(dateToFocusTemp);
        break;

      case "End":
        event.preventDefault();
        dateToFocusTemp.get("day") !== 0 && (dateToFocusTemp = dateToFocusTemp.day(7));
        focusDate(dateToFocusTemp);
        break;

      case " ":
        event.preventDefault();
        onDaySelect(dateToFocusTemp);
        break;
    }
  };

  return /*#__PURE__*/_react["default"].createElement(CalendarContainer, null, /*#__PURE__*/_react["default"].createElement(_main.DxcFlex, {
    alignItems: "center",
    justifyContent: "space-between"
  }, weekDays.map(function (weekDay) {
    return /*#__PURE__*/_react["default"].createElement(WeekHeaderCell, {
      key: weekDay
    }, weekDay);
  })), /*#__PURE__*/_react["default"].createElement(DayCellsContainer, {
    onBlur: handleOnBlur
  }, dayCells.map(function (date, index) {
    return date !== 0 ? /*#__PURE__*/_react["default"].createElement(DayCell, {
      onKeyDown: function onKeyDown(event) {
        return handleDayKeyboardEvent(event, date);
      },
      "aria-label": date.day,
      id: "day_".concat(date.day, "_month").concat(date.month),
      key: "day_".concat(index),
      onClick: function onClick() {
        return onDateClickHandler(date);
      },
      selected: isDaySelected(date, selectedDate),
      actualMonth: date.month === innerDate.get("month"),
      autoFocus: date.day === dateToFocus.get("date") && date.month === dateToFocus.get("month"),
      "aria-selected": isDaySelected(date, selectedDate),
      tabIndex: date.day === dateToFocus.get("date") && date.month === dateToFocus.get("month") ? 0 : -1,
      isCurrentDay: today.get("date") === date.day && today.get("month") === innerDate.get("month") && today.get("month") === date.month && today.get("year") === innerDate.get("year")
    }, date.day) : /*#__PURE__*/_react["default"].createElement(EmptyDayCell, {
      key: "empty_".concat(index)
    });
  })));
};

var CalendarContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0px 8px 8px 8px;\n  width: ", ";\n"])), function (props) {
  return props.theme.dateInput.pickerWidth;
});

var WeekHeaderCell = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 19px;\n  color: ", ";\n"])), function (props) {
  return props.theme.dateInput.pickerFontFamily;
}, function (props) {
  return props.theme.dateInput.pickerWeekFontColor;
});

var DayCellsContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n  justify-content: space-between;\n"])));

var DayCell = _styledComponents["default"].button(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  font-size: 0.875rem;\n  font-family: ", ";\n  font-weight: 400;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n\n  &:focus {\n    outline: ", " solid 2px;\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n  &:active {\n    background-color: #4b1c7d;\n    color: #ffffff;\n  }\n\n  ", "\n  background-color: ", ";\n  color: ", ";\n"])), function (props) {
  return props.theme.dateInput.pickerFontFamily;
}, function (props) {
  return props.theme.dateInput.pickerFocusColor;
}, function (props) {
  return props.selected ? props.theme.dateInput.pickerSelectedDateBackgroundColor : props.theme.dateInput.pickerHoverDateBackgroundColor;
}, function (props) {
  return props.selected ? props.theme.dateInput.pickerSelectedDateColor : props.theme.dateInput.pickerHoverDateFontColor;
}, function (props) {
  return props.isCurrentDay && !props.selected && "border: 1px solid #cbacec;";
}, function (props) {
  return props.selected ? props.theme.dateInput.pickerSelectedDateBackgroundColor : "transparent";
}, function (props) {
  return props.selected ? props.theme.dateInput.pickerSelectedDateColor : props.isCurrentDay ? props.theme.dateInput.pickerActualDateFontColor : !props.actualMonth ? "#999999" : props.theme.dateInput.pickerDayFontColor;
});

var EmptyDayCell = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-block;\n  width: 40px;\n  height: 36px;\n"])));

var _default = /*#__PURE__*/_react["default"].memo(Calendar);

exports["default"] = _default;